var scope_0 = require('/Users/nam.nguyen/Development/github/axon-demo-day-tada/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42b7b9916f163dd090a81bee552fac78.js').default;export default
        Object.assign({}, scope_0 )
    